import { Component, OnInit, Input } from '@angular/core';
import { faPlus, faTrashAlt, faHistory } from '@fortawesome/pro-light-svg-icons';
import { AuthService } from '../../../auth/auth.service';
import { CaseFilesService } from 'src/app/shared/services/casefiles.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-document-preview',
  templateUrl: './document-preview.component.html',
  styleUrls: ['./document-preview.component.scss']
})
export class DocumentPreviewComponent implements OnInit {

  @Input() caseFileId: number = 0;
  notes: any;
  viewInit = false;
  
  thumbnailLoaded = false;
  thumbnailData: string = "";

  @Input() readOnly = true;
  @Input() caseInstructed = true;

  faPlus = faPlus;
  faTrashAlt = faTrashAlt;
  faHistory = faHistory;  

  constructor(public activeModal: NgbActiveModal,
              public authService: AuthService,
              public caseFilesService: CaseFilesService)
              {
  }

  ngOnInit(): void {
  }

  ngAfterContentInit() : void {
    this.viewInit = true;
    this.loadThumbnail();
  }

  loadThumbnail(){

    if (!this.viewInit) return;

    this.caseFilesService.getThumbnail(this.caseFileId).subscribe(response => {
      var base64 = response.body;
      if(base64 != null) {
        this.thumbnailData = base64;
        this.thumbnailLoaded = true;
      }
      else {

      }      
    }, error => {

      var errorMessage = "Failed to get thumbnail";
      if (error.error !== null && error.error.message !== undefined) {
        errorMessage = error.error.message;
      }

    });
  }

  ngOnDestroy(){
  }
}
